import { render, staticRenderFns } from "./backoffice-pre-anestesico.vue?vue&type=template&id=288de45e&scoped=true"
import script from "./backoffice-pre-anestesico.vue?vue&type=script&lang=ts"
export * from "./backoffice-pre-anestesico.vue?vue&type=script&lang=ts"
import style0 from "./backoffice-pre-anestesico.vue?vue&type=style&index=0&id=288de45e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288de45e",
  null
  
)

export default component.exports